import { useRef } from 'react';
export const useBeforeComponentMount = cb => {
  const willMount = useRef(true);
  if (willMount.current) {
    cb();
  }
  willMount.current = false;
};
//# sourceMappingURL=useBeforeComponentMount.js.map